import _ from 'underscore';

import { Filter } from '~commonInfra/utils/Filter';

import { ListResult } from '../../../httpClient/fetchers/ListResult';
import { WebClientListResourceFetcher } from '../../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { Resource } from '../../../httpClient/resources/Resource';
import { RequestHelper } from '../../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../../httpClient/utils/ResultHelper';
import { SliceableHelper } from '../../../httpClient/utils/SliceableHelper';
import WebHttpClient from '../../../httpClient/WebHttpClient';
import { FilterFieldNames, IStringArrayValuedFieldFilterClause } from '../../../spacesPlatform/models/IFilterClause';
import {
  CheckUserNamesRequest,
  ICheckUserNamesResult,
} from '../../users/serverApi/requests/CheckUserNamesRequest';
import { GetUsersRequest, IGetUsersResult } from '../../users/serverApi/requests/GetUsersRequest';
import { SiteRoles } from '../../users/serverApi/types/ISiteRole';
import { IUser } from '../../users/serverApi/types/IUser';
import { SiteRolesResource } from './SiteRoles';

export class Users extends Resource<IUser> {

  public static readonly instance = new Users(new WebClientListResourceFetcher(GetUsersRequest, (result: IGetUsersResult) => result.users));

  public checkUserNames(usernames: string[], identityPoolName?: string): Promise<ICheckUserNamesResult> {
    return WebHttpClient.sendRequests(
      RequestHelper.buildRequests(usernames,
        (usernamesBlock) => new CheckUserNamesRequest({ usernames: usernamesBlock, identityPoolName: identityPoolName })),
      (results: ICheckUserNamesResult[]) => {
        return {
          errors: ResultHelper.combineErrors(results),
          users: ResultHelper.combine(results, (result) => result.users)
        };
      });
  }

  public getUsersById(userIds: string[]): Promise<ListResult<IUser>> {
    return SliceableHelper.fetchAll(this.all()
      .addFilter(Filter.stringFieldInArray('id', userIds)));
  }

  // gets the user with the specified username & domainName.
  public getUserByUsernameAndDomain(username: string, domainName: string): Promise<any> {
    return this.all()
      .addFilter(Filter.stringFieldEq('username', username))
      .addFilter(Filter.stringFieldEq('domainName', domainName))
      .getFirst();
  }

  public getAdminsOnlyFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole, SiteRolesResource.instance.getAdminRoles());
  }

  public getByUserIdsFilter(userIds: string[]): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray('id', userIds);
  }

  public getCanOwnProjectFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole, SiteRolesResource.instance.getProjectOwnershipRoles());
  }

  public getCanOwnMetricFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole, SiteRolesResource.instance.getMetricOwnershipRoles());
  }

  public getCanOwnDatasourceFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole, SiteRolesResource.instance.getDatasourceOwnershipRoles());
  }

  public getWithoutGuestFilter(): IStringArrayValuedFieldFilterClause {
    return Filter.stringFieldInArray(FilterFieldNames.siteRole,
      _.without(SiteRolesResource.instance.allOptions(), SiteRoles.Guest, SiteRoles.Unlicensed));
  }

}

export default Users.instance;
